import { JustpayPointStuffEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-pointStuff-endpoint-service"

export class JustpayPointStuffService {
    constructor () {
        this.justpayPointStuffEndpointService = new JustpayPointStuffEndpointService()
    }

    async getPointStuff(pointId, variableName) {
        const jsonArg = { pointId: pointId, variableName: variableName}
        return this.justpayPointStuffEndpointService.getPointStuff(jsonArg)
    }

    async save (pointId, variableName, value) {
        const jsonArg = { pointId: pointId, variableName: variableName, value: value }
        await this.justpayPointStuffEndpointService.save(jsonArg)
    }
}
